module.exports = __webpack_public_path__ + "img/img11.f2494bee.jpg";